import { Component, inject, Input, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ViewStateRecord } from '@common/data-models/records/viewstate-record';
import { GeneralViewStateTypes, ViewStateTypes } from '@common/enums/viewstate-types';
import { LanguageSettings } from '@common/services/language-settings';
import { NavigationService } from '@common/services/navigation-service';
import { Store } from '@ngrx/store';
import { CreateViewStateActions } from '@src/suite/common/store/createviewstate/createviewstate.actions';
import {
    selectCreateIsInAddContentSourceMode,
    selectCreateViewInEditMode,
    selectIsDiscoverViewState,
    selectIsSaveButtonDisabled,
} from '@src/suite/common/store/createviewstate/createviewstate.selectors';

@Component({
    selector: 'st-view-state',
    templateUrl: './view-state.html',
    styleUrls: ['./view-state.scss'],
    encapsulation: ViewEncapsulation.None,
    // changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'st-view-state',
    },
})
export class ViewStateComponent {
    protected store = inject(Store);

    @Input() onSave: () => Promise<boolean>;

    @Input() onBack: () => any;

    //@Input() onAddViewStateButtonDisabled: () => boolean;
    @Input() onAddViewState: () => any;

    private _viewStateRecord: ViewStateRecord;
    @Input()
    public set viewStateRecord(vs: ViewStateRecord) {
        this._viewStateRecord = vs;
    }
    public get viewStateRecord(): ViewStateRecord {
        return this._viewStateRecord;
    }

    @Input() public loading: boolean = false;

    public generalViewStateTypes = GeneralViewStateTypes;
    public viewStateTypes = ViewStateTypes;

    isSaveButtonDisabled$ = this.store.select(selectIsSaveButtonDisabled);
    isDiscoverViewState$ = this.store.select(selectIsDiscoverViewState);
    inAddContentSourceMode$ = this.store.select(selectCreateIsInAddContentSourceMode);
    inEditMode$ = this.store.select(selectCreateViewInEditMode);

    constructor(
        public navigationService: NavigationService,
        public languageSettings: LanguageSettings,
        public dialogRef: MatDialogRef<ViewStateComponent>
    ) {}

    public async cancel() {
        this.dialogRef.close();
    }

    public async back() {
        this.onBack();
    }

    public async add() {
        this.onAddViewState();
    }

    public async save() {
        try {
            this.store.dispatch(CreateViewStateActions.saveViewState());
            this.dialogRef.close();
        } catch (e) {
            console.log(e.message);
        }
    }
}
